import React from 'react'
import s from './HeaderDetailMainContent.less'
import { TAG_BACK } from '../../store/analytics/analytics.actionTypes'
import classNames from 'classnames'
import SVGIcon from '../svg/SVGIcon'
import TagActionButton from '../genericComponents/TagActionButton'
import { useAction } from '../utils/react-redux'
import { navigateBack } from '../../store/history/history.actions'

const HeaderDetailMainContent = ({ children, className }) => {
  const execNavigateBack = useAction(navigateBack)

  return (
    <div className={classNames(s.root, className)}>
      <TagActionButton type={TAG_BACK} deferClick onClick={() => execNavigateBack()}>
        <div className={classNames('icon', s.backButton)}>
          <SVGIcon icon="chevron" />
        </div>
      </TagActionButton>
      {children}
    </div>
  )
}

export default HeaderDetailMainContent
